module.exports = __webpack_public_path__ + "static/img/duofangguangbo.2939e59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/duofangguangbo.png
// module id = Gv7b
// module chunks = 24